import React, { useContext } from 'react';
import tw from 'twin.macro';
import { PreferenceContext } from '../context';
import { FilterIcon } from 'icons';
import { DropDown, DropDownItem } from '../dropdown';
import { gaEvent } from 'services/ga';

export const SelectImages = ({ ...props }) => <DropDownItem {...props} />;
export const SelectVideos = ({ ...props }) => <DropDownItem {...props} />;

export const MediaFilter = ({ isRight, ...restProps }) => {
  const {
    preference: { filter },
    setPreference,
  } = useContext(PreferenceContext);

  return (
    <DropDown
      label={filter === '' ? 'filter' : `filter: ${filter === 'foto' ? 'plaatjes' : 'videos'}`}
      isRight={isRight}
      iconProps={{
        Type: FilterIcon,
        color: filter ? 'brand' : 'icons',
        animate: true,
      }}
      removeProps={
        filter !== ''
          ? {
              label: 'Verwijder Filter',
              onClick: () => setPreference({ filter: '' }),
            }
          : null
      }
      css={[filter !== '' && tw`ring-2 ring-inset px-3 rounded-full ring-brand w-fit`]}
      {...restProps}
    >
      <SelectImages
        label='Plaatjes'
        selectedValue={filter === 'foto'}
        onClick={() => {
          setPreference({ filter: 'foto' });
          gaEvent('dmp_settings_change', 'set_filter_image');
        }}
      />
      <SelectVideos
        label='Videos'
        selectedValue={filter === 'video'}
        onClick={() => {
          setPreference({ filter: 'video' });
          gaEvent('dmp_settings_change', 'set_filter_video');
        }}
      />
    </DropDown>
  );
};
